import { isString, parseStringRecord, StringRecord } from "./storageValidation";

const PROGRESS_KEY = "kanalearn.grammarProgress.v1";
export type GrammarProgress = StringRecord<string>;

export function getProgress(): GrammarProgress {
    try {
        const raw = localStorage.getItem(PROGRESS_KEY);
        return parseStringRecord(raw, isString);
    } catch {
        return {};
    }
}

export function setProgress(progress: GrammarProgress): void {
    try {
        localStorage.setItem(PROGRESS_KEY, JSON.stringify(progress));
    } catch {
        // Best-effort: if storage is unavailable, progress just won't persist.
    }
}
